import moment from "moment-jalaali";
import momentTz from "moment-timezone";

export const UserCartEditor = {
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        toggleItemInCart(item) {
            const host = this.$store.state.host;
            let found = false;
            if (
                this.user.current_cart &&
                Array.isArray(this.user.current_cart.items)
            ) {
                this.user.current_cart.items.forEach(it => {
                    if (it.id === item.id) {
                        found = true;
                    }
                });
                if (found) {
                    if (typeof this.loading === 'object') {
                        this.loading[item.id] = true;
                    } else {
                        this.loading = true;
                    }
                    host
                        .axios({
                            url: "/api/me/current-cart/remove",
                            method: "POST",
                            headers: host.getWebAuthHeaders({
                                Accept: "application/json",
                                "Content-Type": "applicatinon/json"
                            }),
                            data: {
                                product_id: item.id
                            }
                        })
                        .then(response => {
                            if (typeof this.loading === 'object') {
                                this.loading[item.id] = false;
                            } else {
                                this.loading = false;
                            }
                            const newUser = {
                                ...this.$store.state.user
                            };
                            newUser.current_cart = response.data;
                            this.$store.state.user = newUser;
                        })
                        .catch(error => {
                            if (typeof this.loading === 'object') {
                                this.loading[item.id] = false;
                            } else {
                                this.loading = false;
                            }
                            if (error.response?.data?.message) {
                                host.showSnack(error.response.data.message);
                            } else {
                                host.showSnack(error.message);
                            }
                        });
                }
            }

            if (!found) {
                if (typeof this.loading === 'object') {
                    this.loading[item.id] = true;
                } else {
                    this.loading = true;
                }
                host
                    .axios({
                        url: "/api/me/current-cart/add",
                        method: "POST",
                        headers: host.getWebAuthHeaders({
                            Accept: "application/json",
                            "Content-Type": "applicatinon/json"
                        }),
                        data: {
                            product_id: item.id
                        }
                    })
                    .then(response => {
                        if (typeof this.loading === 'object') {
                            this.loading[item.id] = false;
                        } else {
                            this.loading = false;
                        }
                        const newUser = {
                            ...this.$store.state.user
                        };
                        newUser.current_cart = response.data;
                        this.$store.state.user = newUser;
                    })
                    .catch(error => {
                        if (typeof this.loading === 'object') {
                            this.loading[item.id] = false;
                        } else {
                            this.loading = false;
                        }
                        if (error.response?.data?.message) {
                            host.showSnack(error.response.data.message);
                        } else {
                            host.showSnack(error.message);
                        }
                    });
            }
        },

        getProductPriceString(item) {
            if (item.period_end) {
                return item.data.period_ended ? item.data.period_ended : 'پرداخت قسط'
            }
            const price = this.getProductPriceLabel(item)
            return price.takhfif === '' ? price.price : price.takhfif;
        },

        getProductIsFree (item) {
            return this.getProductPriceSortedList(item)?.length > 0 && item.parent_id == null
        },

        getProductHasOff (item) {
            const price = this.getProductPriceLabel(item)
            return price.takhfif !== '' && price.takhfif
        },

        getProductHasPrice (item) {
            return this.getProductPriceSortedList(item)?.length > 0 && !item.available
        },

        getProductPriceOffString(item) {
            const price = this.getProductPriceLabel(item)
            return price.price
        },

        getProductPriceSortedList (item) {
            const prices = JSON.parse(JSON.stringify(item?.data?.pricing ?? [])).sort(
                (a, b) => a.priority > b.priority
            );
            if (prices.length === 0) {
                (JSON.parse(JSON.stringify(item?.data?.price_periodic ?? []))).sort(
                    (a, b) => a.priority > b.priority
                ).forEach(p => {
                    prices.push(p)
                })
            }
            return prices
        },

        getProductPriceLabel(item) {
            // add prices from pricing
            const prices = this.getProductPriceSortedList(item)
            const label = {}
            if (prices.length === 1) {
                if (prices[0].amount === 0) {
                    label.price = item.data.free_string ?
                        this.field.data.free_string :
                        "رایگان";
                } else {
                    label.price =
                        parseFloat(prices[0].amount).toLocaleString('fa').replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                        " " +
                        this.$store.state.currencies[prices[0].currency];
                }
                label.takhfif = "";
            } else if (prices.length > 1) {
                label.takhfif =
                    parseFloat(prices[0].amount).toLocaleString('fa').replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                    " " +
                    this.$store.state.currencies[prices[0].currency];
                label.price =
                    parseFloat(prices[1].amount).toLocaleString('fa').replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                    " " +
                    this.$store.state.currencies[prices[1].currency];
            } else {
                label.price = item.data.free_string ?
                    item.data.free_string :
                    "رایگان";
                label.takhfif = "";
            }

            return label;
        },

        getProductPriceValue(item) {
            const prices = this.getProductPriceSortedList(item);
            return prices[0];
        },

        hasPeriodicPrice(item) {
            if (item?.data?.calucalte_periodic?.period_duration && item?.data?.calucalte_periodic?.period_count) {
                if (item?.data?.calucalte_periodic?.ends_at) {
                    const end_at = this.getValueDateTime(item?.data?.calucalte_periodic?.ends_at)
                    if (moment().diff(end_at) < 0) {
                        return item.data?.price_periodic?.length > 0
                    }
                }
            }

            return item.data?.price_periodic?.length > 0 && item.data?.pricing?.length > 0
        },

        isSubscription (item) {
            return item?.data?.types?.subscription?.categories
        },

        getProductFirstPeriodPriceValue(item) {
            const prices = item.data?.price_periodic.sort(
                (a, b) => a.priority > b.priority
            );

            return prices[0];
        },

        getProductFirstPeriodPrice(item) {
            const prices = JSON.parse(JSON.stringify(item.data?.price_periodic)).sort(
                (a, b) => a.priority > b.priority
            );

            let amount = prices[0].amount;

            // const giftCode = this.giftCode;
            // if (giftCode) {
            //     if (!giftCode?.products || giftCode?.products?.length === 0 || giftCode?.products?.includes(item.id) && giftCode?.percent) {
            //         if (!giftCode.fixed_only) {
            //             amount = Math.floor(amount * (1 - giftCode.percent));
            //         }
            //     }
            // }

            return parseFloat(amount).toLocaleString('fa').replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ' +
                this.$store.state.currencies[prices[0].currency];
        },
        getValueDateTime(dt) {
            if (dt) {
                if (dt.includes('+')) {
                    const mom = moment(dt, "YYYY/MM/DDTHH:mm:ssZ");
                    mom.locale("fa");
                    return mom;
                } else {
                    const mom = moment(momentTz.utc(dt).tz(momentTz.tz.guess()));
                    mom.locale("fa");
                    return mom;
                }
            }
            return null
        },

        getProductPeriodsLength: function (item) {
            let details = item
            if (item?.data?.calucalte_periodic) {
                details = item?.data?.calucalte_periodic
            }

            if (details?.ends_at && details?.period_duration && details?.period_count > 0) {
                const end_at = this.getValueDateTime(details?.ends_at)
                const diff = Math.abs(moment().diff(end_at, 'day'));
                if (diff >= parseInt(details?.period_count) * parseInt(details?.period_duration)) {
                    return parseInt(details?.period_duration)
                } else {
                    return Math.floor(diff / parseInt(details?.period_count));
                }
            }

            return parseInt(details?.period_duration);
        },

        getProductPeriodsCount: function (item) {
            let details = item
            if (item?.data?.calucalte_periodic) {
                details = item?.data?.calucalte_periodic
            }

            return parseInt(details.period_count)
        },

        getProductPeriodicPriceAmount(item, itemId, giftCode) {
            let amount = parseFloat(item.period_amount);
            if (item.data?.calucalte_periodic?.period_amount) {
                amount = parseFloat(item.data?.calucalte_periodic?.period_amount)
            }

            if (giftCode) {
                if (!giftCode?.products || giftCode?.products?.length === 0 || giftCode?.products?.includes(itemId) && giftCode?.percent) {
                    if (!giftCode.fixed_only) {
                        amount = Math.floor(amount * (1 - parseFloat(giftCode.percent)));
                    }
                }
            }

            return amount
        },
        getProductPeriodicPriceListString(item) {
            const count = this.getProductPeriodsCount(item).toLocaleString('fa')?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const amount = this.getProductPeriodicPriceAmount(item, item.id, this.giftCode)
            const days = this.getProductPeriodsLength(item).toLocaleString('fa')?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const currency = this.$store.state.currencies[1]

            if (this.isSubscription(item)) {
                return `اشتراک ${days} روزه`
            }

            return `و سپس ${count} قسط ${amount.toLocaleString('fa')?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${currency} هر ${days} روز`
        },

        getProductPeriodTitle: function (item) {
            return this.isSubscription(item) ? 'اشتراک ' + (item?.data?.types?.subscription?.label ?? '') + ': ' : 'اقساط: '
        },
    }
};

export const UserAwareComponent = {
    computed: {
        user() {
            return this.$store.state.user;
        },
        isAdmin() {
            const adminRoles = [
                'super-role',
                'affiliate',
                'master',
                'support',
                'support-external',
                'admin',
                'administrator',
                'accounting',
                'manager'
            ];
            return (
                this.$store.state.user &&
                this.$store.state.user.roles &&
                this.$store.state.user.roles.filter(
                    i => adminRoles.includes(i.name) || i.name.endsWith('admin') || i.name.endsWith('manager')
                ).length > 0
            );
        },
        isCustomer() {
            return ( this.$store.state.user && this.$store.state.user.roles );
        },
    },
}
